import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserModel } from '../../../../model/general.model';
import { userOptionLabel } from '../../../../utils/user.utils';
import { StoreService } from '../../../../services/store.service';
import { OrdersService } from '../../../../services/orders.service';
import { OrderUsersModel } from '../../../../model/order.model';

@Component({
  selector: 'order-users-dialog',
  templateUrl: './order-users-dialog.component.html',
  styleUrls: []
})
export class OrderUsersDialogComponent {

  form: FormGroup = this.formBuilder.group({
    users: [[], [Validators.required]]
  })

  constructor(
    public dialogRef: MatDialogRef<OrderUsersDialogComponent>,
    private formBuilder: FormBuilder,
    private store: StoreService,
    private ordersService: OrdersService,
    @Inject(MAT_DIALOG_DATA) public data: OrderUsersModel
  ) {
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.store.showLoader();
      this.ordersService.assignExtraUsers(this.form.value.users, this.data.orderId).subscribe(() => {
        this.dialogRef.close();
        this.store.showSuccessMsg('ORDERS.ADD_INSPECTORS_SUCCESS');
        this.store.refreshOrders();
      })
    }
  }

  getUserLabel(user: UserModel): string {
    return userOptionLabel(user);
  }

}
